export default __webpack_public_path__ + "static/media/premium@3x.73fe0071.png";